import { useContext, useEffect } from "react";
import MapContext, { IMapEventListener, MapEvent } from "../../contexts/data/MapContext";

const useMapEvent = (event: MapEvent, listener: IMapEventListener) => {
    const {events} = useContext(MapContext);

    useEffect(() => {
        const unsubscribe = events.subscribe(event, listener);

        return () => {
            unsubscribe();
        }
    }, [event, listener]);
}

export default useMapEvent;